import React, { useState, useEffect } from "react";
import styles from "./WhosNext.module.css";
import whosNextImage from "../../../assets/whos_next.png";
import bgVideo from "../../../assets/bg.mp4";

const WhosNext = () => {
  const [isAnimated, setIsAnimated] = useState(false);
  const [animationComplete, setAnimationComplete] = useState(false);

  // 컴포넌트 마운트 후 즉시 애니메이션 시작
  useEffect(() => {
    console.log("WhosNext 컴포넌트 마운트됨 - 애니메이션 준비");

    const startTimer = setTimeout(() => {
      console.log("애니메이션 시작 - isAnimated를 true로 설정");
      setIsAnimated(true);
    }, 1000); // 1초 딜레이 후 Who's Next 이미지 등장

    // 애니메이션 완료 후 상태 변경 (1s 딜레이 + 1.5s fade in)
    const completeTimer = setTimeout(() => {
      console.log("애니메이션 완료 - settled 상태로 변경");
      setAnimationComplete(true);
    }, 2600); // 딜레이(1s) + fade in(1.5s) + 여유

    return () => {
      clearTimeout(startTimer);
      clearTimeout(completeTimer);
    };
  }, []);

  return (
    <div className={styles.whosNextContainer}>
      <video className={styles.backgroundVideo} autoPlay muted loop playsInline>
        <source src={bgVideo} type="video/mp4" />
      </video>

      <div
        className={`${styles.imageContainer} ${
          isAnimated ? styles.animated : ""
        } ${animationComplete ? styles.settled : ""}`}
      >
        <img
          src={whosNextImage}
          alt="Who's Next"
          className={styles.whosNextImage}
        />
      </div>
    </div>
  );
};

export default WhosNext;
